import type { CursorPage } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type { TransactionDetail, TransactionListQuery, TransactionSummary } from './types';

export interface TransactionRepository {
  list(query: TransactionListQuery, signal: AbortSignal): Promise<CursorPage<TransactionSummary>>;
  get(transactionId: string, signal: AbortSignal): Promise<TransactionDetail>;
}

export const transactionRepositoryToken =
  createRepositoryToken<TransactionRepository>('transactions');

export const defaultTransactionListQuery = Object.freeze<TransactionListQuery>({
  cursor: '',
  pageSize: 25,
  sort: 'receivedAt',
  filters: {
    partnerId: '',
    agentId: '',
    memberId: '',
    username: '',
    partnerUserId: '',
    uplineMemberId: '',
    uplineUsername: '',
    gameTypeId: '',
    gameTypeCode: '',
    gameId: '',
    gameCode: '',
    gameRound: '',
    partnerTransactionId: '',
    outcome: '',
    status: '',
    reversalState: '',
    currency: '',
    errorCode: '',
    minimumAmount: '',
    maximumAmount: '',
    playFrom: '',
    playTo: '',
    receivedFrom: '',
    receivedTo: '',
  },
});
